<template>
  <el-dialog
    :title="title"
    :visible="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content" v-loading="isLoading">
      <div><label>品牌：</label> <p>{{detailData.brandName}}</p></div>
      <div><label>门店：</label><p>{{detailData.storeName}}</p></div>
      <div><label>推送编号：</label><p>{{detailData.pushNo}}</p></div>
      <div><label>平台单号：</label><p>{{detailData.extOrderId}}</p></div>
      <div><label>logId：</label><p>{{detailData.logId}}</p></div>
      <div><label>推送URL：</label><p>{{detailData.requestUrl}}</p></div>
      <div><label>推送状态：</label><p>{{detailData.pushStatusDesc}}</p></div>
      <div><label>响应状态码：</label><p>{{detailData.httpStatus}}</p></div>
      <div><label>异常信息：</label><p>{{detailData.errorInfo}}</p></div>
      <div><label>推送类型：</label><p>{{detailData.pushTypeDesc}}</p></div>
      <div><label>原始数据：</label><p>{{detailData.originData}}</p></div>
      <div><label>请求内容：</label><p>{{detailData.requestBody}}</p></div>
      <div><label>响应内容：</label><p>{{detailData.responseBody}}</p></div>
      <div><label>推送时间：</label><p>{{detailData.updateTime}}</p></div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancel__btn" @click="$_cancle">放弃</el-button>
    </div>

  </el-dialog>
</template>
<script>

export default {
  name: "modal-modify",
  props: {
    title: { type: String, default: "查看详情" },
    id: { type: Number, default: 0},
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      detailData: {},
    };
  },
  watch: {
    visible: {
      handler(val) {
        if(val) {
          this.$_getDetail()
        }
      }
    }
  },
  methods: {
    async $_getDetail() {
      this.isLoading = true;
      try {
        await this.$service.post('customPushGetById', {id: this.id}).then(result => {
          if (result.$.checkResult(result, true)) { 
            this.detailData = result.data;
          }
        });
      }finally {
        this.isLoading = false
      }
    },
    $_cancle() {
      this.detailData = {}
      this.$emit("update:visible", false);
    },

  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 20px;
  color: #535353;
  font-size: 14px;
  & > div {
    display: flex;
    margin-bottom: 10px;
  }
  label {
    width: 90px;
    display: inline-block;
    text-align: right;
  }
  p {
    display: inline-block;
    margin-left: 10px;
    word-wrap: break-word;
    word-break: break-all;
    flex: 1;
  }
}
</style>
